import { useTranslation } from "react-i18next";
import type { api } from "../lib/api";

type Warning = Awaited<ReturnType<typeof api.sessionSeating>>["warnings"][number];

export default function WarningsPanel({ warnings, onClose }: { warnings: Warning[]; onClose: () => void }) {
  const { t } = useTranslation();

  return (
    <div className="warnings-panel">
      <div className="warnings-panel-head">
        <h2>{t("hallPlan.warningsPanel.heading")}</h2>
        <button onClick={onClose}>{t("hallPlan.warningsPanel.close")}</button>
      </div>
      {warnings.length === 0 ? (
        <p>{t("hallPlan.warningsPanel.empty")}</p>
      ) : (
        <ul className="warnings-list">
          {warnings.map((w, i) => (
            <li key={i}>
              <span className={`warning-badge warning-badge--${w.type}`}>{t(`hallPlan.warningsPanel.types.${w.type}`)}</span>
              <span className="warning-message">{w.message}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
